export const TICKET_NUMBER_LENGTH = 6;

export const TICKET_TABS = {
  NORMAL: 'normal',
  THREE_DIGIT: 'three',
  TWO_DIGIT: 'two',
  RANDOM_10: 'random10',
};

export const RANDOM_PACK_SIZE = 10;

export const DIGIT_TAB_OPTIONS = [
  { id: TICKET_TABS.NORMAL, label: 'ปกติ', digitLength: TICKET_NUMBER_LENGTH },
  { id: TICKET_TABS.THREE_DIGIT, label: '3 ตัว', digitLength: 3 },
  { id: TICKET_TABS.TWO_DIGIT, label: '2 ตัว', digitLength: 2 },
];

export const BET_TYPES = {
  STRAIGHT: 'straight',
  PERMUTATION: 'permutation',
};

export const BET_TYPE_LABELS = {
  [BET_TYPES.STRAIGHT]: 'เต็ง',
  [BET_TYPES.PERMUTATION]: 'โต๊ด',
};

export function getPermutations(digits) {
  const results = new Set();
  const chars = digits.split('');

  function permute(arr, start) {
    if (start === arr.length) {
      results.add(arr.join(''));
      return;
    }
    for (let i = start; i < arr.length; i++) {
      [arr[start], arr[i]] = [arr[i], arr[start]];
      permute(arr, start + 1);
      [arr[start], arr[i]] = [arr[i], arr[start]];
    }
  }

  permute(chars, 0);
  return [...results];
}

export function generateRandomDigits(length) {
  let result = '';
  for (let i = 0; i < length; i++) {
    result += Math.floor(Math.random() * 10);
  }
  return result;
}

export function generateRandomTicketNumber() {
  return generateRandomDigits(TICKET_NUMBER_LENGTH);
}

/** Build full 6-digit ticket: prefix + user suffix */
export function buildFullTicketNumber(suffix, suffixLength, prefix) {
  const prefixLength = TICKET_NUMBER_LENGTH - suffixLength;
  const resolvedPrefix = prefix ?? generateRandomDigits(prefixLength);
  return `${resolvedPrefix}${suffix}`;
}

export function buildTicketsFromSuffix(suffix, suffixLength, betType) {
  const suffixes =
    betType === BET_TYPES.PERMUTATION
      ? getPermutations(suffix)
      : [suffix];

  const prefixLength = TICKET_NUMBER_LENGTH - suffixLength;
  const sharedPrefix = generateRandomDigits(prefixLength);

  return suffixes.map((s) =>
    buildFullTicketNumber(s, suffixLength, sharedPrefix)
  );
}

export function getTicketCountByBetType(suffix, betType) {
  if (betType === BET_TYPES.PERMUTATION) {
    return getPermutations(suffix).length;
  }
  return 1;
}

/** Generate `count` unique random digit strings of given length. */
export function generateUniqueRandomNumbers(length, count = RANDOM_PACK_SIZE) {
  const maxUnique = 10 ** length;
  if (count > maxUnique) {
    throw new Error('requested count exceeds unique space');
  }
  const set = new Set();
  while (set.size < count) {
    set.add(generateRandomDigits(length));
  }
  return [...set];
}
